<!-- This file is for mobile inline fare details -->
<template>
  <div class="fare_desc">

    <div v-if="fareType == 'Premium'">
      <div class="padded">
        <h4>Premium Fare</h4>
        <ul>
          <li>
            <strong>Fully refundable</strong> up to <strong style="color:#b52200">1 hour</strong> prior to departure
          </li>
          <li><strong>Changeable</strong> up to <strong style="color:#b52200">1 hour</strong> prior to departure</li>
          <li>
            Baggage Allowance is <strong>50 lbs</strong>.
            <em>Excess baggage travels space available ${{ baggageFee }}/lb</em>
          </li>
          <li>
            <strong>5 days free parking</strong>
            at our {{ parkingDesc }}
          </li>
        </ul>
      </div>
    </div>
    <div v-if="fareType == 'Classic'">
      <div class="padded">
        <h4>Classic Fare</h4>
        <ul>
          <li>
            <strong>Fully refundable</strong> up to <strong style="color:#b52200">3 hours</strong> prior to departure
          </li>
          <li><strong style="color:#b52200">Only 1 change allowed up to 3 hours prior to departure</strong> to an equal or greater fare</li>
          <li>
            Baggage Allowance is <strong>35 lbs</strong>.
            <em>Excess baggage travels space available ${{ baggageFee }}/lb</em>
          </li>
          <li>
            Up to <strong style="color:#b52200">3 days free parking</strong>, based on availability,
            at our {{ parkingDesc }}
          </li>
					<li><strong>Student &amp; senior discounts only available on this fare type</strong></li>
        </ul>
      </div>
    </div>
		<div v-if="fareType == 'Essential'">
      <div class="padded">
        <h4>Essential Fare</h4>
        <ul>
          <li class="alert">Non-Refundable</li>
          <li>
            <strong style="color:#b52200">Only 1 change allowed up to 3 hours prior to departure</strong>, to a Classic or Premium fare. Fare difference will apply and original fare remains non-refundable.
          </li>
          <li>
            Baggage Allowance is <strong style="color:#b52200">25 lbs</strong>.
            <em>Excess baggage travels space available ${{ baggageFee }}/lb</em>
          </li>
          <li>
            Up to <strong style="color:#b52200">2 days free parking</strong>, based on availability,
            at our {{ parkingDesc }}
          </li>
        </ul>
      </div>
    </div>
    <div v-if="fareType == 'Saver'">
      <div class="padded">
        <h4>Saver Fare</h4>
        <ul>
          <li class="alert">Non-Refundable</li>
          <li>
            <strong style="color:#b52200">Only 1 change allowed up to 5 hours prior to departure</strong>, to a Classic or Premium fare. Fare difference will apply and original fare remains non-refundable.
          </li>
          <li>
            Baggage Allowance is <strong style="color:#b52200">25 lbs</strong>.
            <em>Excess baggage travels space available ${{ baggageFee }}/lb</em>
          </li>
          <li>
            Up to <strong style="color:#b52200">2 days free parking</strong>, based on availability,
            at our {{ parkingDesc }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FareTypes",
  props: ["fareType", "departure", "destination", "parentClass"],
  computed: {
    fareName() {
      console.log("TCL: fareName -> this.fareType.label", this.fareType.label);
      return this.fareType.label;
    },
    isHidden() {
      if (this.parentClass == "selected") {
        return false;
      }
      return true;
    },
    baggageFee() {
			return "1.50";
    },
    parkingDesc() {
      if (this.departure === 1 || this.destination === 1) {
        return "YVR Terminal";
      } else {
        return "YVR or Nanaimo Terminals";
      }
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.fare_desc {
  white-space: normal;
}
.fare_desc .padded ul li {
  line-height: 1.5em;
  margin-left: 1em;
  list-style-type: disc;
}
.fare_desc h4 {
  text-transform: uppercase;
  padding-bottom: 0px;
  padding-top: 1em;
  position: relative;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>
